import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { profile } from "./profile.module";
import { business } from "./business.module";
import { product } from "./product.module";
import { auth } from "./auth.module";

export default createStore({
  modules: {
    profile,
    business,
    product,
    auth
  },
  state: {
    ...business.state,
    ...profile.state,
    ...product.state,
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-gradient-dark",
    isRTL: false,
    color: "success",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isDarkMode: false,
    alertModal: false,
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",

    bootstrap
  },
  mutations: {
    ...business.mutations,
    ...profile.mutations,
    ...product.mutations,
    toggleAlertModal(state) {
      console.log("toggleAlertModal");
      state.alertModal = !state.alertModal;
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
    setIsPinned(state, payload) {
      state.isPinned = payload;
    },
    color(state, payload) {
      state.color = payload;
    },
    navbarMinimize(state) {
      const sidenavShow = document.getElementsByClassName("g-sidenav-show")[0];

      if (sidenavShow.classList.contains("g-sidenav-pinned")) {
        sidenavShow.classList.remove("g-sidenav-pinned");
        sidenavShow.classList.add("g-sidenav-hidden");
        state.isPinned = true;
      } else {
        sidenavShow.classList.remove("g-sidenav-hidden");
        sidenavShow.classList.add("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    }
  },
  actions: {
    ...profile.actions,
    ...business.actions,
    ...product.actions,
    setColor({ commit }, payload) {
      commit("color", payload);
    }
  },
  getters: {
    ...business.getters,
    ...profile.getters,
    ...product.getters,
    getAlertModal(state) {
      return state.alertModal
    },
    getTodayDate() {
      return (new Date()).toISOString().split('T')[0];
    }
  }
});
